var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1221_7277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4359 27.1265H2.18207C1.21935 27.1265 0.438965 26.421 0.438965 25.5507V1.57575C0.438965 0.705462 1.21935 0 2.18207 0H33.4359C34.3986 0 35.179 0.705462 35.179 1.57575V25.5507C35.179 26.421 34.3984 27.1265 33.4359 27.1265Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1787 4.73621H34.3071V22.3896H35.1787V4.73621Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.179 1.57575C35.179 0.705462 34.3986 0 33.4359 0H2.18207C1.21935 0 0.438965 0.705462 0.438965 1.57575V4.73654H35.179V1.57575Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4358 0H32.5642C33.5269 0 34.3073 0.705462 34.3073 1.57575V4.73654H35.1789V1.57575C35.1789 0.705462 34.3983 0 33.4358 0Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.179 25.5506C35.179 26.4209 34.3986 27.1264 33.4359 27.1264H2.18207C1.21935 27.1264 0.438965 26.4209 0.438965 25.5506V22.3898H35.179V25.5506Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3075 22.3898V24.7627C34.3075 25.633 33.5272 26.3385 32.5644 26.3385H1.31065C1.05511 26.3385 0.812997 26.2876 0.594238 26.1983C0.867731 26.7452 1.47503 27.1264 2.1822 27.1264H33.436C34.3987 27.1264 35.1791 26.4209 35.1791 25.5506V22.3898H34.3075Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5496 20.5394H5.0683C4.10558 20.5394 3.3252 19.8339 3.3252 18.9637V8.16333C3.3252 7.29305 4.10558 6.58759 5.0683 6.58759H30.5498C31.5125 6.58759 32.2929 7.29305 32.2929 8.16333V18.9637C32.2927 19.8339 31.5124 20.5394 30.5496 20.5394Z",
    fill: "#3b4559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37084 17.9776C4.1784 17.9776 4.02222 17.8364 4.02222 17.6624V11.6746C4.02222 11.5006 4.1784 11.3594 4.37084 11.3594C4.56328 11.3594 4.71946 11.5006 4.71946 11.6746V17.6624C4.71946 17.8365 4.56328 17.9776 4.37084 17.9776ZM4.37084 10.7279C4.1784 10.7279 4.02222 10.5879 4.02222 10.414V10.4115C4.02222 10.2375 4.1784 10.0963 4.37084 10.0963C4.56328 10.0963 4.71946 10.2375 4.71946 10.4115C4.71946 10.5854 4.56328 10.7279 4.37084 10.7279Z",
    fill: "#B171F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5496 6.58734V17.3877C30.5496 18.258 29.7693 18.9634 28.8065 18.9634H3.3252C3.3252 19.8337 4.10558 20.5392 5.0683 20.5392H30.5498C31.5125 20.5392 32.2929 19.8337 32.2929 18.9634V8.16309C32.2927 7.2928 31.5124 6.58734 30.5496 6.58734Z",
    fill: "#893ADD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.266 6.7276C31.3648 6.92536 31.4211 7.14407 31.4211 7.37523V18.1756C31.4211 19.0458 30.6407 19.7513 29.678 19.7513H4.19664C3.9411 19.7513 3.69898 19.7004 3.48022 19.6111C3.75372 20.158 4.36101 20.5392 5.06819 20.5392H30.5497C31.5124 20.5392 32.2928 19.8337 32.2928 18.9634V8.16311C32.2926 7.52383 31.871 6.97468 31.266 6.7276Z",
    fill: "#6C2BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8127 17.3182V9.80838C13.8127 9.25702 14.4885 8.92501 15.0003 9.22488L21.4085 12.9797C21.8762 13.2537 21.8762 13.8727 21.4085 14.1467L15.0003 17.9016C14.4885 18.2016 13.8127 17.8696 13.8127 17.3182Z",
    fill: "#FFC91D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4085 12.9799L20.8777 12.6689C20.9211 12.9253 20.8083 13.2001 20.5369 13.3591L14.1288 17.1139C14.0277 17.1732 13.9201 17.2069 13.8127 17.22V17.3183C13.8127 17.8696 14.4885 18.2016 15.0003 17.9018L21.4085 14.1469C21.8762 13.8729 21.8762 13.254 21.4085 12.9799Z",
    fill: "#FFA91A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.062 25.9784H10.3008C10.1082 25.9784 9.95215 25.8374 9.95215 25.6633V24.0711C9.95215 23.897 10.1082 23.756 10.3008 23.756H12.062C12.2546 23.756 12.4106 23.897 12.4106 24.0711V25.6633C12.4106 25.8372 12.2546 25.9784 12.062 25.9784Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.062 3.37103H10.3008C10.1082 3.37103 9.95215 3.23 9.95215 3.05588V1.46359C9.95215 1.28947 10.1082 1.14844 10.3008 1.14844H12.062C12.2546 1.14844 12.4106 1.28947 12.4106 1.46359V3.05572C12.4106 3.22984 12.2546 3.37103 12.062 3.37103Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43504 3.37091H3.67382C3.4812 3.37091 3.3252 3.22988 3.3252 3.05576V1.46346C3.3252 1.28934 3.4812 1.14832 3.67382 1.14832H5.43504C5.62766 1.14832 5.78367 1.28934 5.78367 1.46346V3.0556C5.78367 3.22972 5.62748 3.37091 5.43504 3.37091Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43504 25.9784H3.67382C3.4812 25.9784 3.3252 25.8374 3.3252 25.6633V24.0711C3.3252 23.897 3.4812 23.756 3.67382 23.756H5.43504C5.62766 23.756 5.78367 23.897 5.78367 24.0711V25.6633C5.78367 25.8372 5.62748 25.9784 5.43504 25.9784Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6894 3.37103H16.9282C16.7356 3.37103 16.5796 3.23 16.5796 3.05588V1.46359C16.5796 1.28947 16.7356 1.14844 16.9282 1.14844H18.6894C18.8821 1.14844 19.0381 1.28947 19.0381 1.46359V3.05572C19.0381 3.22984 18.8821 3.37103 18.6894 3.37103Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6894 25.9785H16.9282C16.7356 25.9785 16.5796 25.8375 16.5796 25.6634V24.0713C16.5796 23.8971 16.7356 23.7561 16.9282 23.7561H18.6894C18.8821 23.7561 19.0381 23.8971 19.0381 24.0713V25.6634C19.0381 25.8373 18.8821 25.9785 18.6894 25.9785Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3164 3.37103H23.5552C23.3626 3.37103 23.2065 3.23 23.2065 3.05588V1.46359C23.2065 1.28947 23.3626 1.14844 23.5552 1.14844H25.3164C25.509 1.14844 25.665 1.28947 25.665 1.46359V3.05572C25.665 3.22984 25.509 3.37103 25.3164 3.37103Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3164 25.9785H23.5552C23.3626 25.9785 23.2065 25.8375 23.2065 25.6634V24.0713C23.2065 23.8971 23.3626 23.7561 23.5552 23.7561H25.3164C25.509 23.7561 25.665 23.8971 25.665 24.0713V25.6634C25.665 25.8373 25.509 25.9785 25.3164 25.9785Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9441 3.37103H30.1828C29.9902 3.37103 29.8342 3.23 29.8342 3.05588V1.46359C29.8342 1.28947 29.9902 1.14844 30.1828 1.14844H31.9441C32.1367 1.14844 32.2927 1.28947 32.2927 1.46359V3.05572C32.2927 3.22984 32.1367 3.37103 31.9441 3.37103Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9441 25.9785H30.1828C29.9902 25.9785 29.8342 25.8375 29.8342 25.6634V24.0713C29.8342 23.8971 29.9902 23.7561 30.1828 23.7561H31.9441C32.1367 23.7561 32.2927 23.8971 32.2927 24.0713V25.6634C32.2927 25.8373 32.1367 25.9785 31.9441 25.9785Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1221_7277",
    x: 0.438965,
    y: 0,
    width: 34.7402,
    height: 28.1265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1221_7277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1221_7277",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.b9dcb44f4fbcc6c1650dda441a35ddec.svg";
export { ForwardRef as ReactComponent };